export default {
  name: 'Solution |||| Solutions',
  subtitle: 'Here you can manage solutions and define non-financial parameters.',
  fields: {
    features: 'Features',
    productTemplates: 'Product templates',
    featureName: 'Feature Name',
    templateAlias: 'Template Alias',
    editSolution: 'Edit Solution definition',
    solutionDefinition: 'Solution definition',
    name: 'Name',
    addSolution: 'Add Solution',
    noProductTemplate: 'There are no provided product templates yet',
    noFeatures: 'There are no provided features yet',
    noResultsFound: 'No results found',
    category: {
      business: 'Business',
      individual: 'Individual',
      partner: 'Partner',
      other: 'Other',
    },
  },
  tabs: {
    summary: 'Summary',
    products: 'Products',
    pricingTables: 'Pricing plans',
    kycLevels: 'KYC levels',
    handbooks: 'Handbooks',
    fxPlans: 'FX plans',
    featuresConfig: 'Features config',
    notifications: 'Notifications',
    piAvailability: 'PI availability',
    legalConsents: 'Legal Consents',
  },
  Aside: {
    availableFeatures: 'Available features',
    availableProductTemplates: 'Available product templates',
  },
  pricings: {
    addPricing: 'Add pricing plan',
    showPricing: 'Pricing plan information',
    showPricingOld: 'Pricing plan information (Old)',
    name: 'Name',
    pricingPlan: 'Pricing plan',
    viewEdit: 'View/edit values',
    product: 'Product',
    kycLevels: 'KYC levels',
    kycLevel: 'KYC level',
    tags: 'Tags',
    activeFrom: 'Active from',
    activeTill: 'Active till',
    any: 'Any',
    pricingTables: 'Pricing plans',
    solution: 'Solution',
    pricingPlans: 'Pricing plans definitions',
    validityFrom: 'Validity From',
    validityTo: 'Validity To',
    profileKycLevel: 'Profile KYC level',
    paymentInstrument: 'Payment Instrument',
    profileSolution: 'Profile Solution',
    profileTags: 'Profile Tags',
    externalSourceType: 'External Source Type',
    Active: 'Active',
    Blocked: 'Blocked',
    Closed: 'Closed',
    v1: 'v1',
    showOldWarning:
      'You are viewing the old format pricing. Please create a new one as a replacement.',
    editOldWarning:
      'You are editing the old format pricing. Please create a new one as a replacement.',
  },
  products: {
    name: 'Product Name',
    template: 'Product Template',
    regulatoryType: 'Regulatory Type',
    currency: 'Currency',
    accountNumbering: 'Account numbering',
    editProduct: 'Edit Product',
    addProduct: 'Add Product',
    showProduct: 'Product information',
    noData: 'No product templates selected at Summary tab',
    liquidityBucket: 'Liquidity bucket',
    productCode: 'Product code',
    any: 'Any',
    ledgerMappings: {
      ledgerMappings: 'Ledger mappings',
      addMapping: 'Add mapping',
      allSystemsMapped: 'All systems are mapped',
      editLedgerMapping: 'Edit ledger mapping',
      addLedgerMapping: 'Add ledger mapping',
      system: 'System',
      type: 'Type',
      encodedKey: 'Encoded key',
      DEPOSIT: 'New Deposit',
      POOL_DEPOSIT: 'Pool Deposit',
      id: 'ID',
      systems: {
        MAMBU: 'Mambu',
      },
    },
    productTemplateMissing: 'ERROR: missing template',
    productTemplateFallback:
      'Product template for this product is missing. Product can not be used.',
  },
  fxmappings: {
    operationTypes: 'Operation types',
    tags: 'Tags',
  },
  featuresConfig: {
    defaultProduct: 'Default product (deprecated)',
    transitProducts: 'Transit products',
    transitProduct: 'Transit product',
    addTransitProduct: 'Add transit product',
    duplicateCurrency: 'This currency is already configured',
    atLeastOneCurrency: 'At least one currency must be configured',
    defaultMetaProduct: 'Default product (meta) (deprecated)',
    defaultProducts: 'Default products',
    referralCodeInputAttempts: 'Referral code input attempts',
    tenantAccounts: 'Tenant accounts (deprecated)',
    noData: 'No feature configuration available',
    noFeatures: 'There are no provided features yet',
    beneficiarySchema: 'Beneficiary schema',
    remittancePayoutBeneficiarySchema: 'Remittance Payout beneficiary schema',
    fastPayoutProfileSearchRules: 'Rules for searching profile with Fast Payouts',
    fastPayoutEligibilityCheckConnectionKey:
      'Fast Payout eligibility check third-party system connection',
    remittanceAdditionalPropertiesSchema: 'Remittance additional properties schema',
    profileSchema: 'Profile schema',
    legalConsents: 'Legal consents for profile',
    nonAccountBasedPaymentInstruments: 'Non Account-based Payment Instruments',
    employeeConfig: 'Team member configuration',
    serviceChargeSubtype: 'Service charge Subtype',
    countriesAndCurrencies: 'Countries & Currencies',
    remittancePayoutServices: 'Payout services',
    businessPortalBaseUrl: 'Web-portal base URL',
    invitationExpirationPeriod: 'Invitation Expiration Period (days)',
    maxNumberOfInvitationsToPhoneNumberPerMonth:
      'Max number of invitations sent to one number (monthly)',
    maxNumberOfInvitationsByActorPerDay: 'Max number of invitations sent by actor (daily)',
    inviteToSolutionWarning:
      'Changes to the "Invite to Solution" field will directly affect the "Individual Invitation Rewards" feature. If you modify this value, please update the corresponding settings in the rewards configuration to maintain proper functionality.',
    termsAndConditionsLink: 'Terms And Conditions Link',
    websiteLink: 'Website Link',
    phoneNumberPrefixes: 'Phone number prefixes',
    solutionId: 'Solution ID',
    requireMappingToLocation: 'Terminals and their users always linked to location',
    hideAccountBalancesLinkedToTerminal:
      'Hide balances of accounts linked to terminal for team member',
    terminalActivationCodeExpiration: 'Terminal activation code expiration (hours)',
    terminalActivationCodeExpirationHelper:
      'How long an issued activation code remains valid. Leave empty to use the default 24 hours.',
    balanceChecks: 'Balance checks',
    ignoreBalanceChecksOnReversalViaDashboardApi:
      'Ignore balance checks on Reversal via Dashboard UI',
    ignoreBalanceChecksOnForcedApprovalViaDashboardApi:
      'Ignore balance checks on Forced Approval via Dashboard UI',
    ignoreBalanceChecksOnReversalViaIntegrationApi:
      'Ignore balance checks on Reversal via Integration API',
    inviteToSolution: 'Invite to Solution',
    requireRecipientFullNameValidation: 'Require recipient full name validation',
    codeGenerationAlgorithm: 'Code generation algorithm',
    externalSourceType: 'External Source Type',
    externalSourceTypesConfig: 'External Source Types configuration',
    UUID: 'UUID',
    shortCode: 'Short code',
    codeLength: 'Code length',
    codeLifetime: 'Code lifetime (minutes)',
    operationSubtypes: 'Operation subtypes',
    tagsValidation:
      'You can only use uppercase letters and _ symbol. Please remove %{invalidValues}.',
    subEmployeeRoles: 'Sub-employee roles',
    subEmployeeAccountProduct: 'Sub-employee account product',
    category: {
      business: 'Business',
      individual: 'Individual',
      partner: 'Partner',
      other: 'Other',
    },
    enableRewards: 'Enable rewards',
    tenantAccountRewards: 'Tenant account to pay rewards from',
    inviterPaymentInstruments: 'Inviter payment instruments to pay reward to',
    inviteePaymentInstruments: 'Invitee payment instruments to pay reward to',
    inviterRewardCurrency: 'Inviter reward currency',
    inviteeRewardCurrency: 'Invitee reward currency',
    onboardingRewards: 'Onboarding reward',
    enabled: 'Enabled',
    amount: 'Amount',
    amountForInviter: 'Amount (in inviter reward currency)',
    amountForInvitee: 'Amount (in invitee reward currency)',
    processingDelayHours: 'Reward payout delay (in hours)',
    maxInviteeOnboardingDate: 'Invitee onboarding date is on or after',
    operationTypes: 'List of eligible transaction types',
    operationType: 'Operation type',
    serviceIdOrSubtype: 'Service id or subtype',
    transactionTags: 'List of eligible transaction tags',
    value: 'Value',
    currency: 'Currency',
    firstTransactionReward: 'First transaction reward',
    transaction: 'Transaction',
    amountGreaterThan: 'Amount greater than',
    minAmount: 'Minimum transaction amount',
    minAmountAlert:
      'The reward threshold amount will be compared to the amount paid or received by the invitee. If the invitee’s account or payment instrument is in a different currency than the threshold currency, the reward will not be applied. Therefore, if a threshold is required, it is recommended to set the threshold currency to match the invitee’s primary currency.',
    inviterRewards: 'Inviter rewards',
    inviteeRewards: 'Invitee rewards',
    direction: 'Transaction direction for the invitee',
    rewardForInviter: 'Reward for inviter',
    rewardForInvitee: 'Reward for invitee',
    firstTransactionConditions: 'First transaction conditions',
    any: 'Any',
    debit: 'Debit',
    credit: 'Credit',
    inviteePaymentInstrumentsHint:
      'List of products from the invitee solution and external source types. Products are from the solution set in the "Individual Invitation" feature under "Invite to Solution".',
    featureIsNotSetWarning:
      'Please add the "Individual Invitation" feature and specify the "Invite to Solution" field before editing the current feature config.',
    tagsHelperText: "To add tag input it's name and press Enter",
    unknownOption: 'Unknown option',
    tabsAlert:
      'Switching tabs will discard any unsaved changes. Make sure to save your work before navigating to another tab.',
    operationTypeRequired: 'Operation type is required',
    invalidInviteePaymentInstruments: 'Please reset the select due to the invalid value(s)',
    invalidInviteeRewardCurrency:
      'Currency is not available in invitee solution, please select from the provided options',
    isInviteeFeatureMissingError:
      'Please add the "Individual Invitation" feature and specify the "Invite to Solution" field',
    processingParameters: 'Processing parameters',
    cardIssuingSchema: 'Card Issuing schema',
    checkAmount: 'Check amount',
    allowedOperationTypes: 'Allowed operation types',
    reversalWindowMinutes: 'Reversal window (minutes)',
    revertTenantFees: 'Revert tenant fees',

    branch: 'Default branch',
    refundAccounts: 'Refund accounts',
    tenantAccount: 'Tenant account',
    individualAuthTitle: 'Secret word self-reset',
    questions: 'Questions',
    jsonError: 'Invalid JSON format',
    individualAuthDescription:
      'Self-reset allowed only if all accounts of selected products have a balance less than maximum balance defined below',
    warningIndividualAuth:
      'Secret word self-reset is allowed only if all accounts of the selected products have a balance less than the maximum balance defined below. If the profile does not have any account of the specified type, secret word self-reset is allowed. The amount must be greater than zero and less than 100,000,000,000. ',
    product: 'Product',
    addProduct: 'Add product',
    currencyMappingRules: 'Currency mapping rules',
    addCurrencyMappingRule: 'Add currency mapping rule',
    escrowAccount: 'Escrow account',
    targetProducts: 'Target products',
    validityDuration: 'Incoming Transfer validity duration (1–90 days)',
    targetKYC: 'Target KYC level',
    phonePrefixes: 'Allowed phone prefixes',
    phoneHelperText: 'To add phone prefix input its value and press Enter',
    validityDurationMinError: 'Validity duration must be at least %{min} day',
    validityDurationMaxError: 'Validity duration must be at most %{max} days',
    deviceLinkingTitle: 'Device linking',
    maxDevices: 'Maximum number of devices',
    cooldownWindowEnabled: 'New device cooldown window',
    cooldownDuration: 'Cooldown window duration (hours)',
    onboardingPeriod: 'Onboarding period duration (minutes)',
    blockAllTransactions: 'Block all transactions origination',
    blockDebitTransactions: 'Block debit transactions origination',
    otpSmsTitle: 'SMS OTP configuration',
    otpSmsLength: 'OTP length',
    otpSmsDisableManualEntry: 'Disable manual OTP entry',
    mustBeInteger: 'Must be a whole number',
    authSessionTitle: 'Authentication session configuration',
    authSessionLifetime: 'Session lifetime (minutes)',
    authSessionLifetimeMinError: 'Session lifetime must be at least %{min} minute',
    authSessionLifetimeMaxError: 'Session lifetime must be at most %{max} minutes',
    stepUpOtpSmsExpirationTimeout: 'Step-up OTP expiration timeout (minutes)',
    otpSmsExpirationTimeoutMinError:
      'Step-up OTP expiration timeout must be at least %{min} minute',
    otpSmsExpirationTimeoutMaxError:
      'Step-up OTP expiration timeout must be at most %{max} minutes',
    stepUpOtpSmsExpirationTimeoutInfo:
      'Step-up OTP expiration timeout is only applicable for transactions that require step-up authentication.',
    objectDraftsTitle: 'Object drafts settings',
    objectDraftsNotificationDelay: 'Notification delay (seconds)',
    objectDraftsExpirationTtl: 'Expiration TTL (seconds)',
    objectDraftsBatchSize: 'Batch size',
    approvalCasesTitle: 'Approval cases settings',
    approvalCasesDefaultExpirySeconds: 'Default expiry (seconds)',
    approvalCasesClaimBatchSize: 'Claim batch size',
    approvalCasesWatchdogTimeoutMinutes: 'Watchdog timeout (minutes)',
    reversalSupportTitle: 'Reversal settings',
    reversalSupportNotifyRoles: 'Roles notified about external source reversals',
    debitOrderBlockedSenderExemptSubtypes:
      'Debit Order subtypes exempt from sender / out leg account Blocked status',
  },
  handbooks: {
    countries: 'Countries',
    currencies: 'Currencies',
    localizations: 'Localizations',
    kycLevels: 'KYC levels',
    mcc: 'MCC',
    industries: 'Industries',
    branches: 'Branches',
    operationSubtypes: 'Operation subtypes',
    operationSubtypesColumns: {
      operationType: 'Operation type',
      operationSubtype: 'Operation subtype',
      duplicatePair: 'This pair already exists',
      required: 'Required',
      screamingSnakeCase: 'Must be SCREAMING_SNAKE_CASE (uppercase letters and underscores only)',
    },
    error: 'Failed to load handbook',
    hideTabs: 'Collapse',
    showTabs: 'Expand',
  },
  notifications: {
    transactionNotififcations: 'Transactional notifications',
    individualNotfications: 'Individual notifications',
    payerNotififcations: 'Payer notififcations',
    payeeNotififcations: 'Payee notififcations',
    MOBILE: 'Mobile',
    USSD: 'USSD',
    WEB: 'WEB',
    WhatsApp: 'WhatsApp',
    middleware: 'Middleware',
    OTHER: 'Other',
    PROFILE_DEFAULT: 'PROFILE_DEFAULT',
    NO_NOTIFICATION: 'NO_NOTIFICATION',
    SMS_ONLY: 'SMS_ONLY',
    PUSH_WITH_FALLBACK_TO_SMS: 'PUSH_WITH_FALLBACK_TO_SMS',
    individualKYCLevelUpdated: 'Individual KYC level updated',
    individualKYCLevelUpdateRejected: 'Individual KYC level update rejected',
    individualStatusUpdated: 'Individual status updated',
    beneficiaryStatusUpdated: 'Beneficiary status updated',
  },
  paymentInstrumentAvailabilityRules: {
    name: 'Name',
    profileKycLevel: 'Profile KYC level',
    paymentInstrument: 'Payment Instrument',
    externalSourceType: 'External Source Type',
    product: 'Product',
    allowedProfileTags: 'Allowed profile tags',
    disallowedProfileTags: 'Disallowed profile tags',
    noProducts: 'There are no provided products yet',
    noExternalSourceTypes: 'There are no provided external source types yet',
    addPaymentInstrument: 'Add Payment Instrument rules',
    editPaymentInstrument: 'Edit Payment Instrument rules',
    showPaymentInstrument: 'Payment Instrument rules',
    any: 'Any',
  },
};
